import React, { PropTypes } from "react";
import { Button } from "react-bootstrap";
import classNames from "classnames";

const CheckboxButton = (props) => {
  const checkboxClassNames = classNames({
    "checkbox-button": true,
    checked: props.checked,
    "btn-filled": props.checked,
  });

  return (
    <Button
      id={props.id}
      bsStyle="primary"
      className={`${props.className} ${checkboxClassNames}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <span className="checkbox" />
      {props.label}
    </Button>
  );
};

CheckboxButton.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  validation: PropTypes.object,
};

export default CheckboxButton;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxButton.js